<template>
  <div>
    <div class="profileInfo">
      <div class="nameProfileDescription">
        <md-icon>description</md-icon>
        <md-card-content class="descriptionProfile">
          <p>{{ profile.description }}</p>
        </md-card-content>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sidebarProfile",
  computed: {
    profile() {
      return (
        this.$route.params.user || { description: `Adicione uma breve descrição para contar mais sobre você às pessoas` }
      );
    }
  },
};
</script>

<style scoped>
.imgBackgroundProfile {
  position: absolute;
  top: 0;
  height: 120px;
  border-bottom: solid 1px;
}

.profileInfo {
  position: relative;
  overflow: hidden;
}

.divImgAvatar {
  position: relative;
  display: block;
  background-color: #fff;
  /* bottom: 69px; */
  padding: 3px;
  width: fit-content;
  border-radius: 100%;
  /* border-top: solid 1px; */
  margin: auto;
}

.md-avatar.avatarProfile {
  width: 100px;
  height: 100px;
}

/* .md-avatar{
  position: relative;
  top: 0;
  margin: 0
} */

.nameProfileDescription {
  /* position: absolute; */
  /* top: 145px; */
  /* bottom: 50px;
  margin-top: 5px;  */
  padding: 10px;
  text-align: center;
}

.descriptionProfile {
  padding-bottom: 0px;
}

</style>
